function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5fd6fba9\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./Google.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./Google.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5fd6fba9\"}!../../../vue-loader/lib/selector?type=template&index=0!./Google.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5fd6fba9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/Google.vue
// module id = 645
// module chunks = 0